import { colors } from '@nandosaus/constants';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import React, { useState } from 'react';

import { Box, Flex } from '@components/grid';
import { P } from '@components/typography/new';
import { inputSize } from '@constants';
import { Button } from '@components/button';
import { BUTTON_VARIANTS } from '@components/button/constants';
import { pStyles } from '../typography/body';

const SuccessBorderedFlex = styled(Flex)`
  border: 1px solid ${({ theme }) => theme.colors.black};
  min-height: ${inputSize.sm};
  ${pStyles('small')};
  padding: 8px;
  width: 100%;
  border-radius: 4px;
`;

const StyledButton = styled(Button)`
  padding: 0px;
  margin-right: 8px;
`;

const Url = styled(P)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-right: 16px;
`;

const CopyTextButton = ({ onClick, text, label }) => {
  const [isLinkCopied, setIsLinkCopied] = useState(false);

  const handleOnClick = () => {
    onClick();
    navigator.clipboard.writeText(text);
    setIsLinkCopied(true);
  };

  return (
    <Box px="32px">
      {label && (
        <P variant="small-semi-bold" color="black" mb="4px">
          {label}
        </P>
      )}
      <SuccessBorderedFlex justifyContent="space-between" alignItems="center" width="100%">
        <Url variant="small" textTransform="none" color={colors.black}>
          {text}
        </Url>
        <StyledButton variant={BUTTON_VARIANTS.LINK} onClick={handleOnClick}>
          <P variant="medium-link" textTransform="none" color={colors.black} textDecoration="underline">
            {isLinkCopied ? 'Copied' : 'Copy Link'}
          </P>
        </StyledButton>
      </SuccessBorderedFlex>
    </Box>
  );
};

CopyTextButton.propTypes = {
  text: PropTypes.string.isRequired,
  label: PropTypes.string,
  onClick: PropTypes.func,
};

CopyTextButton.defaultProps = {
  label: null,
  onClick: () => null,
};

export { CopyTextButton };
